import { VersionRange } from '../../models/core/version-range.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { PhotoReference } from '../../models/serializable/file-reference/photo-reference.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class CoverImageComponent extends Component {
  static readonly TYPE_ID: string = 'ce623d915310493797dbec434db1d491';
  static readonly SCHEMA_VERSION: number = 1;

  constructor(
    public readonly coverImage: PhotoReference,
  ) {
    super();
  }

  get $typeId(): string {
    return CoverImageComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.exactly(CoverImageComponent.SCHEMA_VERSION);
  }

  static fromMap(context: SerializationContext, map: SerializedData): CoverImageComponent {
    return new CoverImageComponent(
        context.fromData<PhotoReference>(MapUtils.getRaw(map, 'coverImage') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'coverImage': context.toData(this.coverImage),
    };
  }

  clone(): this {
    return new CoverImageComponent(
        this.coverImage.clone(),
    ) as this;
  }

  isSame(other: CoverImageComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.coverImage, this.coverImage);
  }
}

export class CoverImageComponentBuilder extends DataModelBuilder<CoverImageComponent> {
  build(context: SerializationContext, map: SerializedData): CoverImageComponent {
    return CoverImageComponent.fromMap(context, map);
  }
}
